module.exports = __webpack_public_path__ + "img/azure-blob.9bee8475.svg";